/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export const getDefaultWebpageCardStyle = (link) => {
    if (link?.is_external) {
        return "external";
    } else {
        return "default";
    }
};
